import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2rem;

  padding: 2rem;

  text-align: center;
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  img {
    height: 3rem;
  }
`;

export const Main = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  width: 100%;
  max-width: 50rem;

  h1,
  > p {
    margin: 0;
  }

  h1 {
    color: var(--secondary-color);
  }

  #timer {
    font-variant-numeric: tabular-nums;
  }
`;

export const QrCodeImage = styled.img`
  width: 12.5rem;
  height: 12.5rem;
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  height: 3.125rem;
  width: 25rem;
  max-width: 100%;
  padding: 0 1rem;
  border-radius: 6px;

  cursor: pointer;
  background-color: transparent;
  border: none;

  transition: filter 0.2s ease-in-out;

  &:disabled {
    opacity: 0.8;
    cursor: not-allowed;
  }

  &:hover {
    filter: brightness(0.95);
  }

  ${({ variant }) =>
    variant === "primary"
      ? css`
          background-color: var(--primary-color);
          color: white;
        `
      : css`
          box-shadow: rgba(0, 0, 0, 0.3) 0px 5px 15px;
          background-color: white;
        `}

  img {
    height: 50%;
  }
`;

export const ReceiptTable = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ReceiptItem = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 1rem;

  & + div {
    border-top: 1px solid #c7c7c7;
  }

  p:last-child {
    color: ${({ color }) => color || "inherit"};
  }
`;
